import React, { useState } from "react";
import { ToastContainer } from "react-toastify";
//import Loader from "../../components/Loader/Loader"; // Import your loader component
import GetEquity from "./GetEquity";
import General from "./General";
import KYCApproval from "./KYC";

function Marketplace() {
  //const [loading, setLoading] = useState(false); // State for loading
  const [activeSection, setActiveSection] = useState(null); // Track which section is open

  // Toggle section visibility
  const toggleSection = (section) => {
    setActiveSection((prevSection) =>
      prevSection === section ? null : section,
    );
  };

  return (
    <div>
      {/* {loading && (
        <div className="overlay">
          <Loader />
        </div>
      )} */}

      {/* General */}
      <div
        style={{
          marginBottom: "16px",
          border: "1px solid #ccc",
          borderRadius: "8px",
        }}
      >
        <div
          style={{
            padding: "12px",
            cursor: "pointer",
            backgroundColor: "#f9f9f9",
            borderBottom:
              activeSection === "general" ? "1px solid #ccc" : "none",
          }}
          onClick={() => toggleSection("general")}
        >
          <strong>General (All)</strong>
        </div>
        {activeSection === "general" && (
          <div style={{ padding: "12px", backgroundColor: "#ffffff" }}>
            <General />
          </div>
        )}
      </div>

      {/* KYC */}
      <div
        style={{
          marginBottom: "16px",
          border: "1px solid #ccc",
          borderRadius: "8px",
        }}
      >
        <div
          style={{
            padding: "12px",
            cursor: "pointer",
            backgroundColor: "#f9f9f9",
            borderBottom: activeSection === "kyc" ? "1px solid #ccc" : "none",
          }}
          onClick={() => toggleSection("kyc")}
        >
          <strong>Approve KYC</strong>
        </div>
        {activeSection === "kyc" && (
          <div style={{ padding: "12px", backgroundColor: "#ffffff" }}>
            <KYCApproval />
          </div>
        )}
      </div>

      {/* Get Equity */}
      <div
        style={{
          marginBottom: "16px",
          border: "1px solid #ccc",
          borderRadius: "8px",
        }}
      >
        <div
          style={{
            padding: "12px",
            cursor: "pointer",
            backgroundColor: "#f9f9f9",
            borderBottom:
              activeSection === "getEquity" ? "1px solid #ccc" : "none",
          }}
          onClick={() => toggleSection("getEquity")}
        >
          <strong>GetEquity</strong>
        </div>
        {activeSection === "getEquity" && (
          <div style={{ padding: "12px", backgroundColor: "#ffffff" }}>
            <GetEquity />
          </div>
        )}
      </div>

      {/* Portfolio Dashboard Section */}
      {/* <div
        style={{
          marginBottom: "16px",
          border: "1px solid #ccc",
          borderRadius: "8px",
        }}
      >
        <div
          style={{
            padding: "12px",
            cursor: "pointer",
            backgroundColor: "#f9f9f9",
            borderBottom:
              activeSection === "portfolio" ? "1px solid #ccc" : "none",
          }}
          onClick={() => toggleSection("portfolio")}
        >
          <strong>Portfolio Dashboard</strong>
        </div>
        {activeSection === "portfolio" && (
          <div style={{ padding: "12px", backgroundColor: "#ffffff" }}>
            <PortfolioDashboard />
          </div>
        )}
      </div> */}

      {/* Toast Notifications */}
      <ToastContainer />
    </div>
  );
}

export default Marketplace;
